export default "__VITE_ASSET__88ce0ed5__"